export default __webpack_public_path__ + "img/1a940772a5f4f47ed6c24041de867426.svg";